/** Restart a page when the server reports an obsolete ranking cursor. */
export async function fetchMapListingsPage(
  requestBody: Record<string, unknown>,
  csrfToken: string,
  signal: AbortSignal,
) {
  let body: Record<string, unknown> = { ...requestBody, includeSummary: !requestBody.cursor };
  let restarted = false;
  const send = () =>
    fetch(`${process.env.REACT_APP_API_URL}/off-market-listings-in-bounds`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken,
      },
      body: JSON.stringify(body),
      signal,
    });
  let response = await send();
  if (response.status === 400 && body.cursor) {
    const error = await response.json();
    if (error.code === 'invalid_cursor') {
      body = { ...body };
      delete body.cursor;
      body.includeSummary = true;
      restarted = true;
      response = await send();
    }
  }
  if (!response.ok) throw new Error('Map listings search failed');
  return { data: await response.json(), restarted };
}

/**
 * Cancel a viewport search that has not left its debounce window yet. The
 * caller can also lower loading placeholders when no real request owns them.
 */
export function cancelPendingMapListingsSearch(
  timerRef: { current: number | null },
  hasActiveRequest: boolean,
  onCancelledIdleSearch: () => void,
) {
  const handle = timerRef.current;
  if (handle === null) {
    if (!hasActiveRequest) onCancelledIdleSearch();
    return false;
  }
  window.clearTimeout(handle);
  timerRef.current = null;
  if (!hasActiveRequest) onCancelledIdleSearch();
  return true;
}
